import { render } from "./modal-filtros.vue?vue&type=template&id=1c1e6c30"
import script from "./modal-filtros.vue?vue&type=script&lang=js"
export * from "./modal-filtros.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__